import Api from '../lib/api';

const Qs = require('qs');

const config = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
};

export default {

  webhook(url, data) {
    return Api(config).post(url, Qs.stringify(data))
  },

  sendEmail(data) {
    return this.webhook('https://hooks.zapier.com/hooks/catch/563716/eqvmbv/', data)
  },

}